<template>
  <div class="wrap">
    <!-- 自定义导航栏 -->
    <Nav></Nav>
    <!-- 自定义导航栏 -->
    <!-- 注册-->
    <div class="register-wrap">
      <div>
        <div class="register-action">
          <div class="register-padding">
            <div class="register-title">注册</div>
            <div class="input-wrap">
              <img src="../../../assets/img/login_btn_user.png" alt="">
              <input type="text" placeholder="请输入昵称" v-model="nickname"
                onkeyup="this.value=this.value.replace(/[, ]/g,'')">
              <img v-show="nickname" src="../../../assets/img/login_btn_cancel.png" alt="" @click="clear('nickname')">
            </div>
            <div class="input-wrap">
              <img src="../../../assets/img/login_btn_phone.png" alt="">
              <input type="text" placeholder="请输入手机号码" v-model="phone" @input="checkPhone">
              <img v-show="phone" src="../../../assets/img/login_btn_cancel.png" alt="" @click="clear('phone')">
            </div>
            <div class="code-wrap">
              <div class="text-wrap">
                <img src="../../../assets/img/login_btn_validation.png" alt="">
                <input type="text" v-model="code" placeholder="请输入验证码">
              </div>
              <div v-show="!showCountDown" class="code-btn" @click="sendSms">
                获取验证码
              </div>
              <div v-show="showCountDown" class="clock-btn">
                重新发送({{ countDown }})s
              </div>
            </div>
            <div class="input-wrap">
              <img src="../../../assets/img/login_btn_password.png" alt="">
              <input type="password" placeholder="设置登录密码" v-model="password">
              <img v-show="password" src="../../../assets/img/login_btn_cancel.png" alt="" @click="clear('password')">
            </div>
            <div class="input-wrap">
              <img src="../../../assets/img/login_btn_password.png" alt="">
              <input type="password" placeholder="确认登录密码" v-model="repassword">
              <img v-show="repassword" src="../../../assets/img/login_btn_cancel.png" alt="" @click="clear('repassword')">
            </div>
            <div class="operate-wrap">
              <div class="go-login">已有账号？<span @click="toLogin">马上登录</span></div>
            </div>
            <div class="go-register" @click="register">注册</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 注册-->
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import { registerSms, register } from '@/api/user'
export default {
  name: 'Home',
  components: {
    Nav
  },
  data() {
    return {
      nickname: '',  //用户名
      password: '',  //密码
      repassword: '', //确认密码
      phone: '',  //手机号
      code: '',  //验证码
      invite_code: '',//邀请人UUID
      showCountDown: false,//显示倒计时
      countDown: 60,  //倒计时
      loading: false,
      tip: '',
      redirect: undefined
    }
  },
  created() {
    if (this.$route.query.invite_code) {
      this.invite_code = this.$route.query.invite_code
    } else {
      this.invite_code = localStorage.getItem('inviteCode')
    }
    if (this.$route.query.redirect) {
      this.redirect = this.$route.query.redirect
    }
  },
  methods: {
    sendSms() {
      if (!this.validateNickname() || !this.validatePhone()) {
        this.$Message.error(this.tip)
        return
      }
      this.showCountDown = true
      registerSms({
        nickname: this.nickname,
        mobile: this.phone,
      }).then(response => {
        this.$Message.success(response.message)
        this.timer = setInterval(() => {
          this.countDown--
          if (this.countDown === 0) {
            this.showCountDown = false
            this.countDown = 60;
            clearInterval(this.timer)
          }
        }, 1000)
      }).catch(error => {
        console.log(error)
        this.showCountDown = false
      })
    },
    register() {
      let isSaas = localStorage.getItem('isSaas')
      if (this.loading) {
        return
      }
      if (!this.validateNickname() || !this.validatePhone() || !this.validateCode || !this.validatePassword()) {
        this.$Message.error(this.tip)
        return
      }
      this.loading = true
      register({
        nickname: this.nickname,
        password: this.password,
        repassword: this.repassword,
        mobile: this.phone,
        code: this.code,
        invite_code: this.invite_code,
        domainName: this.$domain
      }).then(response => {
        this.loading = false
        this.$Modal.success({
          title: '提示',
          content: '注册成功！',
          okText: '立即登录',
          onOk: () => {
            if (this.$domain.indexOf('movie')!=-1) {
              if (isSaas == 1) {
                this.$router.push({ path: this.redirect || '/pc/home', query: { type: 'saasmovie' } })
              } else {
                this.$router.push({ path: this.redirect || '/pc/home' })
              }
            } else {
              this.$router.push({ path: this.redirect || '/pc/proxyHome/index' })
            }
          },
          onCancel: () => {

          }
        });
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    },
    //清除文本框
    clear(val) {
      this[val] = ''
    },
    //监听手机
    checkPhone() {
      this.phone = this.phone.replace(/[^\d]/g, '')
    },
    // 验证手机
    validatePhone() {
      if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phone))) {
        this.tip = '手机号格式不正确'
        return false;
      }
      return true;
    },
    //验证昵称
    validateNickname() {
      if (!this.nickname.length) {
        this.tip = '请输入昵称'
        return false;
      }
      if (this.nickname.length < 3 || this.nickname.length > 32) {
        this.tip = '用户名为3~32位字符'
        return false;

      }
      return true;
    },
    //验证密码
    validatePassword() {
      if (this.password.length < 6 || this.password.length > 18) {
        this.tip = '密码长度6到18位'
        return false;
      }

      if (this.password != this.repassword) {
        this.tip = '两次密码输入不一致'
        return false
      }
      return true
    },
    //验证 验证码
    validateCode() {
      if (!(this.code.length == 6)) {
        this.tip = '验证码长度错误'
        return false;
      }
      return true
    },
    //跳转到登录界面
    toLogin() {
      if (this.$store.state.user.isSaasProxyUser == 1) {
        this.$router.push({ path: this.redirect || '/pc/proxyHome/index' })
      } else {
        this.$router.push({ path: this.redirect || '/pc/home' })
      }
    },
  }
}
</script>

<style>
.wrap {
  min-width: 850px;
}

/* 注册*/
.register-wrap {
  height: 480px;
  width: 100%;
  margin-top: 10px;
}

.register-wrap .register-action {
  background: #FFFFFF;
  width: 30%;
  max-width: 560px;
  min-width: 460px;
  height: 560px;
  margin-top: 50px;
  margin: auto;
}

.register-wrap .register-action .register-padding {
  padding: 30px 60px;
}

.register-wrap .register-action .register-title {
  font-family: Alibaba-PuHuiTi-M;
  font-size: 32px;
  color: #222222;
  line-height: 80px;
  text-align: center;
}

.register-wrap .register-action .input-wrap,
.register-wrap .register-action .code-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 10px;
  background: #FFFFFF;
  border: 1px solid #EEEEEE;
  border-radius: 2px;
  margin-top: 20px;
}

.register-wrap .register-action .code-wrap {
  border: none;
  padding: 0;
}

.register-wrap .register-action .input-wrap img,
.register-wrap .register-action .code-wrap img {
  cursor: pointer;
  width: 24px;
  height: 24px;
}

.register-wrap .register-action .input-wrap input {
  width: 90%;
  font-size: 14px;
  color: #222222;
  padding: 5px;
  border: none;
}

.register-wrap .register-action .code-wrap input {
  width: 80%;
  padding: 5px;
}

.register-wrap .register-action .code-wrap .text-wrap {
  width: 60%;
  height: 100%;
  border: 1px solid #EEEEEE;
  border-radius: 2px;
  padding: 5px 10px;
}

.register-wrap .register-action .code-btn,
.register-wrap .register-action .clock-btn {
  width: 40%;
  height: 42px;
  line-height: 42px;
  text-align: center;
  cursor: pointer;
  margin-left: 10px;
}

.register-wrap .register-action .code-btn,
.register-wrap .register-action .clock-btn {
  border: 1px solid #FF9734;
  border-radius: 2px;
  color: #FF9734;
}

::-webkit-input-placeholder {
  font-family: Alibaba-PuHuiTi-R;
  font-size: 14px;
  color: #C1C1C1;
  letter-spacing: 0;
}

.operate-wrap {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #666666;
  margin-top: 16px;
  width: 100%;
  overflow: hidden;
}

.operate-wrap .go-login {
  float: right;
  cursor: pointer;
}

.operate-wrap .go-login span {
  color: #FF4F76;
}

.go-register {
  cursor: pointer;
  color: #FFFFFF;
  background: #FF9734;
  border-radius: 2px;
  margin-top: 20px;
  text-align: center;
  height: 48px;
  line-height: 48px;
}

/* 注册*/
</style>



// WEBPACK FOOTER //
// src/views/pc/register/Index.vue